import React from 'react';
import { Container } from '../container';
import { CreateAddress } from '../address-modal/CreateAddress';
import { Modal, ModalContents, ModalOpenButton } from '../../../modal';
import styled from 'styled-components';
import { AddressBook } from './AddressBook';
import { buttonType } from '../../../button';
import { colors } from '../../../../theme/color';
import { useUser } from '../../../../hooks/useUser';
import {
  CreateUserAddressRequest,
  UpdateUserAddressRequest,
  UserAddressDto,
} from '@kotipizzagroup/kotipizza-users-api-client';

type AddressBookProps = {
  onAddressSelect: (address: UserAddressDto | undefined) => void;
  createAddress: (address: CreateUserAddressRequest) => Promise<UserAddressDto>;
  updateAddress: (address: UpdateUserAddressRequest) => Promise<void>;
  deleteAddress: (address: UserAddressDto) => Promise<void>;
  setDefaultAddress: (address: UserAddressDto) => Promise<void>;
};

const StyledModalOpenButton = styled(ModalOpenButton)`
  max-width: 95%;
  margin: 10px auto 8px;
`;

export const DesktopAddressBook: React.FC<AddressBookProps> = ({
  onAddressSelect,
  createAddress,
  updateAddress,
  deleteAddress,
  setDefaultAddress,
}) => {
  const { user } = useUser();
  const addresses = user?.addresses || [];

  const handleAddressUpdate = async (address: UpdateUserAddressRequest): Promise<void> => {
    await updateAddress(address);
  };

  const handleAddressDelete = async (address: UserAddressDto): Promise<void> => {
    await deleteAddress(address);
  };

  const handleSetDefaultAddress = async (address: UserAddressDto): Promise<void> => {
    await setDefaultAddress(address);
  };

  return (
    addresses.sort((a, b) => Number(b.primaryAddress) - Number(a.primaryAddress)) && (
      <Container
        backgroundColor={colors.white}
        borderRadius="4px"
        style={{ textAlign: 'center', padding: '0 0 10px' }}
      >
        <div>
          <AddressBook
            onAddressSelect={onAddressSelect}
            updateAddress={handleAddressUpdate}
            deleteAddress={handleAddressDelete}
            setDefaultAddress={handleSetDefaultAddress}
          />
        </div>

        <Modal name="desktopAddressBookModal">
          <StyledModalOpenButton type={buttonType.SECONDARY}>
            + Lisää uusi osoite
          </StyledModalOpenButton>

          <ModalContents
            maxWidth="sm"
            fullWidth={true}
            title="Lisää kuljetusosoite"
            aria-labelledby="create-address-modal"
            aria-describedby="create-address-modal"
          >
            <CreateAddress createAddress={createAddress} setDefaultAddress={setDefaultAddress} />
          </ModalContents>
        </Modal>
      </Container>
    )
  );
};
